import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { EmptyReport } from '@widgets/FinanceExportTable/ui/EmptyReport';
import { Loader } from '@widgets/FinanceExportTable/ui/Loader';

import cls from './FinanceExportTable.module.css';
import { ReportRow } from './ReportRow/ReportRow';
import { useFinanceExportTable } from '../lib/hooks/useFinanceExportTable';

export const FinanceExportTable = () => {
    const { reports, isLoading, handleDelete, handleRetry, handleDownload } =
        useFinanceExportTable();

    const { t } = useTranslation();

    if (isLoading) {
        return <Loader classes={cls.row} />;
    }

    if (!reports?.length) {
        return <EmptyReport />;
    }

    return (
        <div className={cls.tableWrapper}>
            <table className={cls.table}>
                <thead>
                    <tr className={cn(cls.headerRow, cls.row)}>
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <th className={cls.thStatus} />
                        <th className={cls.th}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.type'
                            )}
                        </th>
                        <th className={cls.th}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.object'
                            )}
                        </th>
                        <th className={cls.th}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.params'
                            )}
                        </th>
                        <th className={cls.th}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.period'
                            )}
                        </th>
                        <th className={cls.th}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.create'
                            )}
                        </th>
                        <th className={cls.thActions}>
                            {t(
                                'FinanceExportTable.return.tableWrapper.table.thead.headerRow.th.actions'
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {reports?.map((report) => (
                        <ReportRow
                            classes={cls.row}
                            key={report.id}
                            report={report}
                            onDelete={handleDelete}
                            onRetry={handleRetry}
                            onDownload={handleDownload}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};
